import React from 'react'
import {useContext, useRef, useState, useEffect} from 'react'
import {useGraphData} from './effects'
import {ReducerContext} from './reducer'
import {auth} from '../Auth'
import embed from 'vega-embed'

function intervalLabel(interval) {
  switch (interval) {
    case '7_day': return '7-day';
    case '30_day': return '30-day';
    case '90_day': return '90-day';
    case '180_day': return '180-day';
    case '365_day': return '365-day';
    case 'all_time': return 'All Time';
    default: return '30-day';
  }
}

function makeGraphConfig(data, interval) {
  const label = intervalLabel(interval)
  return {
    data: {name: 'table', values: data},
    background: null,
    width: window.innerWidth * 0.7,
    height: window.innerHeight * 0.5,
    padding: 3,
    autosize: 'pad',
    layer: [
      {
        mark: {type: 'line', interpolate: 'monotone', strokeWidth: 6, color: '#5C8EF0'},
        encoding: {
          x: {field: 'date', type: 'temporal'},
          y: {field: 'score', type: 'quantitative'},
        },
      },
      {
        mark: {
          type: 'point',
          color: '#913831',
          shape: 'triangle',
          filled: true,
          size: 150,
        },
        encoding: {
          x: {
            field: 'date',
            type: 'temporal',
            title: null,
            axis: {
              labelAngle: -45,
              labelFontSize: 12,
              format: '%d %b',
              formatType: 'time'
            },
          },
          y: {
            field: 'score',
            type: 'quantitative',
            title: `${label} Project Average`,
            axis: {
              titleFontSize: 25,
              labelFontSize: 15,
              offset: 10,
            },
          },
          tooltip: [
            {field: 'score', type: 'quantitative', title: 'Average Score'},
            {field: 'projects_included', type: 'quantitative', title: 'Number of Projects Included'},
            {field: 'date', type: 'temporal', title: 'Date', format: '%d %b %Y'},
          ],
        },
      },
    ],
    config: {
      legend: {
        disable: true,
      },
    },
    scales: [
      {
        name: 'x',
        type: 'time',
        range: 'width',
        domain: {data: 'table', field: 'date'},
      },
      {
        name: 'y',
        type: 'linear',
        range: 'height',
        nice: true,
        zero: true,
        domain: [0, 100],
      },
    ],
  }
}

export default function OSPlot() {
  const {state} = useContext(ReducerContext)
  const plotRef = useRef(null)
  const [config, setConfig] = useState(undefined)
  useGraphData()

  const interval = state.dropdown.interval || '30_day'

  useEffect(
    function () {
      const newConfig = makeGraphConfig(state.graphData, interval)
      setConfig(newConfig)
    },
    [state.graphData, window.innerHeight, window.innerWidth, interval]
  )

  useEffect(() => {
    (async function () {
      if (!plotRef || !plotRef.current) return
      if (!config) return

      await embed(plotRef.current, config)
    })()
  }, [plotRef.current, state.graphData, config])

  // embed( plotRef, config )

  return (
    <div className="background-none margin-right-2 padding-1">
      <h4>
        Projects Score Rolling Average for {auth.sunkaizenUser.organization.name}
        {state.dropdown.orgRole && state.dropdown.orgRole !== 'undefined' && (
          <span> as {state.dropdown.orgRole}</span>
        )}
      </h4>
      <div className="full-width" ref={plotRef} />
    </div>
  )
}
